import { hasOption, rankWith, uiTypeIs } from '@jsonforms/core';
import type { ControlProps } from '@jsonforms/core';
import React from 'react';

export interface SlotControlProps extends ControlProps {
    type: 'Slot';
    slotsMapping?: Record<string, React.ReactNode>;
}

const SlotControlComponent = ({ uischema, slotsMapping }: SlotControlProps) => {
    return <>{slotsMapping?.[uischema?.options?.slot] || null}</>;
};

export const SlotControlTester = rankWith(10, uiTypeIs('Slot') && hasOption('slot'));

export const SlotControlRenderer = (props: SlotControlProps) => <SlotControlComponent {...props} />;
